import { render, staticRenderFns } from "./ToTokPayPrivacy.vue?vue&type=template&id=35a5bcb1&scoped=true"
import script from "./ToTokPayPrivacy.vue?vue&type=script&lang=js"
export * from "./ToTokPayPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ToTokPayPrivacy.vue?vue&type=style&index=0&id=35a5bcb1&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a5bcb1",
  null
  
)

export default component.exports